"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.sizes = {
    xs: 12,
    sm: 18,
    md: 24,
    lg: 34,
    xl: 42,
};
exports.default = react_jss_1.createUseStyles({
    opened: {},
    wrapper: function (_a) {
        var size = _a.size, theme = _a.theme;
        return (__assign(__assign({}, theme_1.getFocusStyles(theme)), { WebkitTapHighlightColor: 'transparent', borderRadius: theme.radius.sm, width: theme_1.getSizeValue({ size: size, sizes: exports.sizes }) + theme.spacing.xs, height: theme_1.getSizeValue({ size: size, sizes: exports.sizes }) + theme.spacing.xs, padding: theme.spacing.xs / 2, backgroundColor: 'transparent', border: 0, cursor: 'pointer' }));
    },
    burger: function (_a) {
        var size = _a.size, theme = _a.theme, color = _a.color, reduceMotion = _a.reduceMotion;
        var sizeValue = theme_1.getSizeValue({ size: size, sizes: exports.sizes });
        return {
            position: 'relative',
            userSelect: 'none',
            boxSizing: 'border-box',
            '&, &:before, &:after': {
                display: 'block',
                width: sizeValue,
                height: Math.ceil(sizeValue / 12),
                backgroundColor: theme_1.getThemeColor({
                    theme: theme,
                    color: color,
                    shade: theme.colorScheme === 'dark' ? 4 : 7,
                }),
                outline: '1px solid transparent',
                transitionProperty: 'background-color, transform',
                transitionDuration: reduceMotion ? '0ms' : '300ms',
            },
            '&:before, &:after': {
                position: 'absolute',
                content: '""',
                left: 0,
            },
            '&:before': {
                top: (sizeValue / 3) * -1,
            },
            '&:after': {
                top: sizeValue / 3,
            },
            '&$opened': {
                backgroundColor: 'transparent !important',
                '&:before': {
                    transform: "translateY(" + sizeValue / 3 + "px) rotate(45deg)",
                },
                '&:after': {
                    transform: "translateY(-" + sizeValue / 3 + "px) rotate(-45deg)",
                },
            },
        };
    },
}, { link: true });
